/* eslint-disable no-use-before-define */
import React from 'react'
import useMessages from './use-messages'

export default () => {
    const { status, Status, messages, onDismiss } = useMessages()

    return <React.Fragment>
    { status === Status.LOADED && messages.length>0 && (
        messages
        .map( (m,i) => (<Message key={i} message={m} onDismiss={onDismiss} />))
    )}
    </React.Fragment>
}

const Message = ({message:msg, onDismiss}) => {

    let header = msg.header || `message-${msg.seq}`
    let content = `
    <h4 aria-live="assertive" class="universal-message-heading vertical-offset-sm">${header}</h4>
    ${msg.message}
    `

    return <div className="row"><div className="col-xs-12">
    <div
        data-name="messages-message"
        className="universal-message universal-message-info universal-message-dismissible"
        role="alert">

    <button
        data-name="messages-message-close"
        className="close"
        onClick={() => onDismiss(msg.messageId) }
        >
        <i className="material-icons" aria-hidden="true">close</i>
        <span className="sr-only">Close</span>
    </button>

    <div
        data-name="messages-message-content"
        className="universal-message-content"
        style={{width:'100%'}}
        dangerouslySetInnerHTML={{ __html:content}} />

    </div>
    </div></div>
}